(() => {
  const WIDTH_MIN = 40;
  const WIDTH_MAX = 200;
  const DROP_MIN = 84;
  const DROP_MAX = 240;
  const SIZE_STEP = 0.5;
  const ORIGINAL_BASE_CHARGE = 50;
  const AREA_DIVISOR = 36;
  const PRICE_MULTIPLIER = 1.2767;

  const isHalfInchSize = (value) => Math.abs(value * 2 - Math.round(value * 2)) < 1e-9;

  const roundHalfEven = (value, decimalPlaces = 2) => {
    const factor = 10 ** decimalPlaces;
    const scaled = value * factor;
    const lower = Math.floor(scaled);
    const fraction = scaled - lower;
    const tieTolerance = Number.EPSILON * Math.max(1, Math.abs(scaled)) * 4;

    if (Math.abs(fraction - 0.5) <= tieTolerance) {
      return (lower % 2 === 0 ? lower : lower + 1) / factor;
    }

    return Math.round(scaled) / factor;
  };

  const calculate = (width, drop) => {
    const numericWidth = Number(width);
    const numericDrop = Number(drop);
    const isValid =
      Number.isFinite(numericWidth) &&
      Number.isFinite(numericDrop) &&
      numericWidth >= WIDTH_MIN &&
      numericWidth <= WIDTH_MAX &&
      numericDrop >= DROP_MIN &&
      numericDrop <= DROP_MAX &&
      isHalfInchSize(numericWidth) &&
      isHalfInchSize(numericDrop);

    if (!isValid) return null;

    // Match the workbook's two-stage rounding: round the original price first,
    // then apply the 27.67% increase and round the selling price.
    const originalPrice = roundHalfEven(ORIGINAL_BASE_CHARGE + (numericWidth * numericDrop) / AREA_DIVISOR, 2);
    return Number((originalPrice * PRICE_MULTIPLIER).toFixed(2));
  };

  window.RadiantCurtainPricing = Object.freeze({
    calculate,
    constraints: Object.freeze({
      widthMin: WIDTH_MIN,
      widthMax: WIDTH_MAX,
      dropMin: DROP_MIN,
      dropMax: DROP_MAX,
      step: SIZE_STEP
    })
  });
})();
